export interface HistoricalDataLimits {
  startYear: number;
  endYear: number;
  yearRange: number;
  isRestricted: boolean;
  description: string;
}

export const useHistoricalDataLimits = () => {
  const currentYear = new Date().getFullYear();

  // Traffic-first model: full historical data (1988-present) is free for every
  // visitor. Deep multi-decade history is a differentiator versus competitors,
  // so we no longer truncate it by tier.
  const startYear = 1988;
  const endYear = currentYear;
  const yearRange = endYear - startYear + 1;

  return {
    startYear,
    endYear,
    yearRange,
    isRestricted: false,
    description: "Full historical data access (1988-present)"
  };
};